import { IContact } from '@dataTypes/contact.type'

/** Placeholder contacts for Message Center until the contact API is available. */
export const MOCK_CONTACTS: IContact[] = [
  {
    contact_id: 'mock-contact-1',
    clinic_id: 'mock-clinic',
    first_name: 'Jordan',
    last_name: 'Lee',
    address: '120 Maple Ave',
    city: 'Irvine',
    state: 'CA',
    zip: '92602',
    cellphone: '9495550101',
    email: 'jordan.lee@example.com',
    fax_number: '9495550102',
    preferred_call_method: 'cellphone',
    is_hidden: false,
    date_time_created_at: '2026-07-10T09:15:00Z',
  },
  {
    contact_id: 'mock-contact-2',
    clinic_id: 'mock-clinic',
    first_name: 'Priya',
    last_name: 'Patel',
    title: 'Dr.',
    address: '88 Harbor Blvd',
    city: 'Newport Beach',
    state: 'CA',
    zip: '92660',
    cellphone: '9495550202',
    email: 'priya.patel@example.com',
    work_phone: '9495550203',
    fax_number: '9495550204',
    preferred_call_method: 'work_phone',
    is_hidden: false,
    date_time_created_at: '2026-07-12T14:30:00Z',
  },
  {
    contact_id: 'mock-contact-3',
    clinic_id: 'mock-clinic',
    first_name: 'Marcus',
    last_name: 'Nguyen',
    address: '415 Palm St',
    city: 'Santa Ana',
    state: 'CA',
    zip: '92701',
    cellphone: '7145550303',
    email: 'marcus.nguyen@example.com',
    home_phone: '7145550304',
    preferred_call_method: 'cellphone',
    is_hidden: false,
    date_time_created_at: '2026-07-15T11:00:00Z',
  },
]
